var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ico-more") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Adherence-Phase-1",
    transform: "translate(-127.000000, -517.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico-more",
    transform: "translate(127.000000, 517.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-3",
    fill: "#D1DCE6",
    cx: 8.5,
    cy: 8.5,
    r: 8.5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "+",
    fill: "#44484C",
    fillRule: "nonzero",
    points: "9.423 11.596 9.423 9.139 11.906 9.139 11.906 7.345 9.423 7.345 9.423 4.888 7.577 4.888 7.577 7.345 5.107 7.345 5.107 9.139 7.577 9.139 7.577 11.596"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMore);
export default __webpack_public_path__ + "static/media/ico-more.f1b1b97806ecff084097f4a4874ea390.svg";
export { ForwardRef as ReactComponent };